module.exports = __webpack_public_path__ + "img/QRcode.2f4c5abe.jpg";